import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SocieteViewItemComponent } from './components/societe-view-item.component';
import { ConfirmDialogModule, ConfirmationService, BreadcrumbModule, AutoCompleteModule, DropdownModule } from 'primeng/primeng';
import { InputTextModule } from 'primeng/inputtext';
import { AuthorizeRoleDirective } from '../../services/security/authorize-role.directive';
import { BaseComponent } from './components/base.component';
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';
import { MoneyInputComponent } from './components/money-input.component';
import { KeyFilterModule } from 'primeng/keyfilter';
import { TabViewComponent } from './components/tab-view/tab-view.component';
import { TabPanelComponent } from './components/tab-panel/tab-panel.component';
import { TabNavComponent } from './components/tab-nav/tab-nav.component';
import { ClickStopPropagation } from './directives/click-stop-propagation.directive';
import { AppStepperComponent } from './components/stepper/stepper/stepper.component';
import { AppStepperItemComponent } from './components/stepper/stepper-item/stepper-item.component';
import { BreadCrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { CivilityPipe } from './pipes/civility.pipe';
import { CountrySelectionInputComponent } from './components/adress/country-selection-input.component';
import { CodePostalInputComponent } from './components/adress/code-postal-input.component';
import { QuestionSecurityComponent } from '@modules/account/login/components/question-security/question-security.component';
import { CheckBlankValidatorDirective } from '@shared/validators/checkBlank.validator';

@NgModule({
  imports: [
    CommonModule,
    ConfirmDialogModule,
    InputTextModule,
    SidebarModule,
    ToastModule,
    FormsModule,
    KeyFilterModule,
    BreadcrumbModule,
    AutoCompleteModule,
    DropdownModule, 
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    SocieteViewItemComponent,
    AuthorizeRoleDirective,
    BaseComponent,
    MoneyInputComponent,
    TabViewComponent,
    TabPanelComponent,
    TabNavComponent,
    ClickStopPropagation,
    AppStepperComponent,
    AppStepperItemComponent,
    BreadCrumbComponent,
    CivilityPipe,
    CountrySelectionInputComponent,
    CodePostalInputComponent, 
    QuestionSecurityComponent,
    CheckBlankValidatorDirective
  ],
  providers: [
    ConfirmationService
  ],
  exports: [
    SocieteViewItemComponent,
    ConfirmDialogModule,
    InputTextModule,
    AuthorizeRoleDirective,
    BaseComponent,
    SidebarModule,
    ToastModule,
    MoneyInputComponent,
    KeyFilterModule,
    TabViewComponent,
    TabPanelComponent,
    TabNavComponent,
    ClickStopPropagation,
    AppStepperComponent,
    AppStepperItemComponent,
    BreadCrumbComponent,
    CivilityPipe,
    CountrySelectionInputComponent,
    CodePostalInputComponent,
    QuestionSecurityComponent
  ]
})
export class AppCommonModule { }
